var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="about_empty"> <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100605'] ))==null?'':__t)+
'</li> </ol> </div> </div> </section> <section class="content-block page-bg"> <div class="overlay tint"> <div class="container"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4>'+
((__t=( resources['X100605'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100605'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100606'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100607'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100608'] ))==null?'':__t)+
'</p> </div> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="row"> <div class="col-sm-4 col-md-4" style="text-align:center;;padding-bottom:30px"> <img src="images/app01.jpg" class="approtateleft" alt="pic" style="width:50%"> </div> <div class="col-sm-8 col-md-8 vspace-xs"> <h4>'+
((__t=( resources['X100609'] ))==null?'':__t)+
'</h4> <div class="row"> <div class="col-xs-12 col-sm-12 col-md-12"> <ul class="list-unstyled list-icon mb20"> <li>'+
((__t=( resources['X100610'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100611'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100612'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100613'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100614'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100615'] ))==null?'':__t)+
'</li> </ul> </div> </div> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="row"> <div class="col-sm-8 col-md-8 vspace-xs" style="padding-bottom:30px"> <h4>'+
((__t=( resources['X100616'] ))==null?'':__t)+
'</h4> <div class="row"> <div class="col-xs-12 col-sm-12 col-md-12"> <ul class="list-unstyled list-icon mb20"> <li>'+
((__t=( resources['X100617'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100618'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100619'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100620'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100621'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100622'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100623'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100624'] ))==null?'':__t)+
'</li> <li>'+
((__t=( resources['X100625'] ))==null?'':__t)+
'</li> </ul> </div> '+
((__t=( resources['X100626'] ))==null?'':__t)+
' </div> </div> <div class="col-sm-4 col-md-4" style="text-align:center"> <img src="images/app02.jpg" class="approtateright" alt="pic" style="width:50%"> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4 class="no-margin-t">'+
((__t=( resources['X100627'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100628'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100629'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100630'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100631'] ))==null?'':__t)+
'</p> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4>'+
((__t=( resources['X100632'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100633'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100634'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100635'] ))==null?'':__t)+
'</p> </div> </div> </div> </section> </div>';
}
return __p;
};
